import { Box, Typography, makeStyles } from "@material-ui/core";
import dayjs from "dayjs";
import React, { FC, useMemo } from "react";
import { useHistory } from "react-router";
import { useRecoilValue } from "recoil";

import { homeCardStyle } from "@/components/home/HomeSection";
import { ProposalListCard } from "@/components/offer/ProposalListCard";
import { semanticColors, layoutTokens } from "@/designTokens";
import { useGetInvestmentProposals } from "@/hooks/useGetInvestmentProposals";
import { AppEventTokenEnum, sendEventToAppMeasurementTool } from "@/utilities/capacitorLogic";
import { UserState } from "@/view_models/atoms";

const useStyles = makeStyles(() => ({
  card: {
    ...homeCardStyle,
    padding: layoutTokens.space[24],
    display: "flex",
    flexDirection: "column",
    gap: layoutTokens.space[16],
  },
  subtitle: {
    color: semanticColors["text/secondary"],
    marginTop: layoutTokens.space[8],
  },
  agentCardWrapper: {
    border: `1px solid ${semanticColors["border/default"]}`,
    borderRadius: layoutTokens.radius.md,
    overflow: "hidden",
  },
}));

// ホーム（PC）右レールの「新規通知」。最新の未読投資メッセージを1件表示する（Figma 161:1457 参照）
export const NewNotificationSection: FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const user = useRecoilValue(UserState);
  const { investmentProposals, loading } = useGetInvestmentProposals();

  const latestUnread = useMemo(() => {
    return [...investmentProposals]
      .filter((proposal) => !proposal.is_user_read)
      .sort((a, b) => dayjs(b.proposal_date ?? 0).valueOf() - dayjs(a.proposal_date ?? 0).valueOf())[0];
  }, [investmentProposals]);

  if (loading || !latestUnread) return null;

  const onClickCard = () => {
    // adjust向けに既読イベント発火（メッセージ一覧のカード押下と同じ扱い）
    const params = user?.id ? { user_id: user.id } : undefined;
    sendEventToAppMeasurementTool(AppEventTokenEnum.ReadProposal, params);
    history.push(`/investment/${latestUnread.id}`);
  };

  return (
    <Box className={classes.card}>
      <Box>
        <Typography variant="h4">新規通知</Typography>
        <Typography variant="caption" component="p" className={classes.subtitle}>
          あなたへ新しいメッセージが届いています
        </Typography>
      </Box>
      <Box className={classes.agentCardWrapper}>
        <ProposalListCard
          profileImagePath={latestUnread.agent?.agent_profile_image?.image_url || ""}
          representativeName={`${latestUnread.agent?.family_name ?? ""}${latestUnread.agent?.first_name ?? ""}`}
          companyName={latestUnread.agent?.company?.name ?? ""}
          message={latestUnread.short_appeal_message || latestUnread.agent?.company?.short_appeal_message}
          proposalDate={latestUnread.proposal_date}
          isUnread
          showUnreadBadge={false}
          strengthLabels={[]}
          selected={false}
          onClick={onClickCard}
        />
      </Box>
    </Box>
  );
};
